import React, { useRef, useState } from "react";
import "./ProposalForm.css";
import Switch from "../../Componenets/Switch/Switch.js";
import { IconAlerta, IconEmail, IconMensagem } from "../../Shared/Icons/Icons";
import { CANAIS_ENVIO } from "../Proposals/propostaFormato";
import {
  EMPRESAS,
  EMPRESA_PADRAO,
  buscarEmpresa,
} from "../../Shared/Empresas/empresas";

const ICONE_CANAL = { whatsapp: IconMensagem, email: IconEmail };

const PRAZOS = [
  "Imediato",
  "7 dias úteis",
  "15 dias úteis",
  "30 dias úteis",
  "45 dias úteis",
  "60 dias úteis",
];

function validar({ empresa, link, deliveryTime, canalEnvio }) {
  const erros = {};

  if (!buscarEmpresa(empresa)) {
    erros.empresa = "Selecione a empresa que emite a proposta.";
  }

  if (!link.trim()) {
    erros.link = "Informe o link da proposta no Tiny.";
  } else if (!/^https?:\/\//i.test(link.trim())) {
    erros.link = "O link precisa começar com http:// ou https://.";
  }

  if (!deliveryTime) {
    erros.deliveryTime = "Selecione o prazo de entrega.";
  }

  if (!canalEnvio) {
    erros.canalEnvio = "Selecione por onde a proposta vai ser enviada.";
  }

  return erros;
}

function MensagemErro({ id, children }) {
  return (
    <p id={id} className="field-error">
      <IconAlerta size={16} />
      {children}
    </p>
  );
}

export default function ProposalForm() {
  const [empresa, setEmpresa] = useState(EMPRESA_PADRAO);
  const [link, setLink] = useState("");
  const [deliveryTime, setDeliveryTime] = useState("");
  const [canalEnvio, setCanalEnvio] = useState("");
  const [salvarDados, setSalvarDados] = useState(true);
  const [erros, setErros] = useState({});
  const empresaRef = useRef(null);
  const linkRef = useRef(null);
  const prazoRef = useRef(null);
  const canalRef = useRef(null);

  const handleEmpresaChange = (valor) => {
    setEmpresa(valor);
    if (erros.empresa) setErros((atuais) => ({ ...atuais, empresa: undefined }));
  };

  const handleLinkChange = (e) => {
    setLink(e.target.value);
    if (erros.link) setErros((atuais) => ({ ...atuais, link: undefined }));
  };

  const handleDeliveryTimeChange = (e) => {
    const value = e.target.value;
    setDeliveryTime(value);
    sessionStorage.setItem("deliveryTime", value);
    if (erros.deliveryTime) {
      setErros((atuais) => ({ ...atuais, deliveryTime: undefined }));
    }
  };

  const handleCanalChange = (valor) => {
    setCanalEnvio(valor);
    if (erros.canalEnvio) {
      setErros((atuais) => ({ ...atuais, canalEnvio: undefined }));
    }
  };

  const resetFields = () => {
    setEmpresa(EMPRESA_PADRAO);
    setLink("");
    setDeliveryTime("");
    setCanalEnvio("");
    setSalvarDados(true);
    sessionStorage.removeItem("empresa");
    sessionStorage.removeItem("proposalLink");
    sessionStorage.removeItem("deliveryTime");
    sessionStorage.removeItem("canalEnvio");
    sessionStorage.removeItem("salvarDados");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const novosErros = validar({ empresa, link, deliveryTime, canalEnvio });
    setErros(novosErros);

    if (novosErros.empresa) {
      empresaRef.current?.focus();
      return;
    }
    if (novosErros.link) {
      linkRef.current?.focus();
      return;
    }
    if (novosErros.deliveryTime) {
      prazoRef.current?.focus();
      return;
    }
    if (novosErros.canalEnvio) {
      canalRef.current?.focus();
      return;
    }

    // A captura roda na aba /Loading, que recebe uma copia do sessionStorage.
    sessionStorage.setItem("empresa", empresa);
    sessionStorage.setItem("proposalLink", link.trim());
    sessionStorage.setItem("deliveryTime", deliveryTime);
    sessionStorage.setItem("canalEnvio", canalEnvio);
    sessionStorage.setItem("salvarDados", String(salvarDados));

    window.open("/Loading", "_blank");
    resetFields();
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Nova proposta</h1>
        <p className="page-subtitle">
          Cole o link da proposta no Tiny para gerar o PDF comercial.
        </p>
      </div>

      <form className="card proposal-form" onSubmit={handleSubmit} noValidate>
        <fieldset
          className={`field grupo-opcoes${erros.empresa ? " grupo-opcoes--erro" : ""}`}
          aria-describedby={
            erros.empresa ? "proposta-empresa-erro" : "proposta-empresa-ajuda"
          }
        >
          <legend className="field-label">Empresa emissora</legend>
          <div className="opcoes">
            {EMPRESAS.map(({ valor, rotulo, cnpj }, indice) => (
              <label key={valor} className="opcao">
                <input
                  ref={indice === 0 ? empresaRef : undefined}
                  type="radio"
                  name="proposta-empresa"
                  value={valor}
                  checked={empresa === valor}
                  onChange={() => handleEmpresaChange(valor)}
                />
                <span className="opcao-cartao opcao-cartao--empresa">
                  {rotulo}
                  <span className="opcao-detalhe">CNPJ {cnpj}</span>
                </span>
              </label>
            ))}
          </div>
          {erros.empresa ? (
            <MensagemErro id="proposta-empresa-erro">{erros.empresa}</MensagemErro>
          ) : (
            <p id="proposta-empresa-ajuda" className="field-hint">
              Nome e CNPJ que saem no cabeçalho do PDF.
            </p>
          )}
        </fieldset>

        <div className="field">
          <label htmlFor="proposta-link" className="field-label">
            Link da proposta no Tiny
          </label>
          <input
            ref={linkRef}
            id="proposta-link"
            type="url"
            inputMode="url"
            autoComplete="off"
            className="field-input"
            placeholder="https://erp.tiny.com.br/..."
            value={link}
            onChange={handleLinkChange}
            aria-invalid={Boolean(erros.link)}
            aria-describedby={
              erros.link ? "proposta-link-erro" : "proposta-link-ajuda"
            }
          />
          {erros.link ? (
            <MensagemErro id="proposta-link-erro">{erros.link}</MensagemErro>
          ) : (
            <p id="proposta-link-ajuda" className="field-hint">
              Abra a proposta no Tiny e copie o endereço da página.
            </p>
          )}
        </div>

        <div className="field">
          <label htmlFor="proposta-prazo" className="field-label">
            Prazo de entrega
          </label>
          <select
            ref={prazoRef}
            id="proposta-prazo"
            className="field-input"
            value={deliveryTime}
            onChange={handleDeliveryTimeChange}
            aria-invalid={Boolean(erros.deliveryTime)}
            aria-describedby={
              erros.deliveryTime ? "proposta-prazo-erro" : undefined
            }
          >
            <option value="" disabled>
              Selecione o prazo de entrega
            </option>
            {PRAZOS.map((prazo) => (
              <option key={prazo} value={prazo}>
                {prazo}
              </option>
            ))}
          </select>
          {erros.deliveryTime && (
            <MensagemErro id="proposta-prazo-erro">
              {erros.deliveryTime}
            </MensagemErro>
          )}
        </div>

        <fieldset
          className={`field grupo-opcoes${erros.canalEnvio ? " grupo-opcoes--erro" : ""}`}
          aria-describedby={
            erros.canalEnvio ? "proposta-canal-erro" : "proposta-canal-ajuda"
          }
        >
          <legend className="field-label">Enviar proposta por</legend>
          <div className="opcoes">
            {CANAIS_ENVIO.map(({ valor, rotulo }, indice) => {
              const Icone = ICONE_CANAL[valor];
              return (
                <label key={valor} className="opcao">
                  <input
                    ref={indice === 0 ? canalRef : undefined}
                    type="radio"
                    name="proposta-canal"
                    value={valor}
                    checked={canalEnvio === valor}
                    onChange={() => handleCanalChange(valor)}
                  />
                  <span className="opcao-cartao">
                    <Icone size={18} />
                    {rotulo}
                  </span>
                </label>
              );
            })}
          </div>
          {erros.canalEnvio ? (
            <MensagemErro id="proposta-canal-erro">{erros.canalEnvio}</MensagemErro>
          ) : (
            <p id="proposta-canal-ajuda" className="field-hint">
              Fica registrado na proposta, em Propostas.
            </p>
          )}
        </fieldset>

        <Switch
          id="proposta-salvar-dados"
          label="Deseja salvar os dados da proposta?"
          description="Grava o cliente e a proposta, que passa a aparecer em Propostas. Desmarque para apenas gerar o PDF."
          checked={salvarDados}
          onChange={setSalvarDados}
        />

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">
            Gerar PDF
          </button>
        </div>
      </form>
    </div>
  );
}
